<div style="width: 100%;" class="mt-4 pt-1">

  <div class="col-md-12    p-2 rounded">
    <form class="form-inline w-100 float-right mt-1  ">


      <section class="content-header w-100  d-flex justify-content-between  px-2 align-items-center  ">
  
        <h3 translate>Schedule Settings</h3>
  
        <div class="d-flex flex-wrap">
        <div class="d-flex pr-4 text-white ">
          <a class="btn  btn-sm text-white border-white btnblue" style="background-color: rgb(17, 47, 77);" (click)='backClicked()' translate><i class="fa fa-times mx-1"></i> BACK</a>
        </div>

        <div class="d-flex pr-4 text-white ">
          <a class="btn  btn-sm text-white border-white btnblue" style="background-color: rgb(17, 47, 77);"  (click)='addModal(addMainSalesRepModal)' translate><i class="fa fa-user mx-1"></i> ADD SALES REP</a>
        </div>
      </div>
      </section>

    </form>

    <div class="">
        <section class="content-header  d-flex justify-content-end  px-2 align-items-center  " style="height: 20px;">
           

            <ol class="breadcrumb bg-transparent  mt-2">
              <li class="breadcrumb-item " style="font-size: 12px; " translate>Home</li>
              <li class="breadcrumb-item" style="font-size: 12px; " translate>Schedule Settings</li>
            </ol>

        </section>
    </div>
</div>



    
    <div class="row p-0 w-100 m-2">
    <div class="col-md-12 " >
    <div class="row w-100 box box-primary rounded border-top border-primary shadow-sm bg-white  "   >



        <div class="col-md-12 h-50">

    
            <form [formGroup]="addSalesRepToMainListForm" >
       
               <div class=" border p-3 m-1 rounded   " >
                   <h6 class="table-heading rounded text-white text-center p-3 " style="background-color: rgb(17, 47, 77)"  href="#scheduleView" data-toggle="collapse" data-target="#categoryView"  translate>Sales Representative
                          <div class="p-1 mr-3">
                       <input class=" p-2 m-2 w-100 mx-2 text-center rounded "  type="text" placeholder="Search" [ngModelOptions]="{standalone: true}"  [(ngModel)]="searchText"
              aria-label="Search" >
               
            </div></h6>
                   
           <div  aria-expanded="false" style="overflow:auto; height: 300px;"  id="scheduleView"s>
               <table class="table w-100  text-center"  style="font-size: 12px;">
                           
                  <th>Name</th>
                  <th>Email</th>
                  <th>Action</th>
                                           
       
                 
                   <tr *ngFor='let user of mainSalesRep |  filter:searchText'>
                   <td>{{user.fullName}}</td>
                   <td>{{user.email}}</td>
                   <td><i class="fa fa-trash" style="cursor: pointer;" (click)='deleteSalesRepFromMainList(user)'></i></td>
                   </tr>
                   
       
               </table>
          </div>
               </div>
       
          
         
            
             <div class="modal-footer " style="bottom:0">
              <button type="button" class="btn btn-secondary" translate >Close</button>
              <button type="submit" class="btn btn-primary" (click)=addSalesRepToMainlist(); translate>Add</button>
             </div>
            </form>
           
       
   
       </div>
   

       


        </div>
        </div>
        </div>

        </div>

             <!----------Add Main Sales Rep Modal------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------>
             <ng-template #addMainSalesRepModal let-modal>
                <div class="modal-header text-white" style="background-color: rgb(17, 47, 77);">
                 <h5 class="modal-title" id="statuLabel">Add Sales Rep</h5>
                 <button type="button" class="close text-white" style=" outline: none;" (click)="modal.dismiss()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                 </button>
                </div>
                
                <div class="modal-body">
                 <form [formGroup]="addSalesRepToMainListForm" style="font-family: DINPro;" >
            
   
            <!--{{addSalesRepToMainListForm.value |json}}-->
                    <div class="form-group row ">
                  
                      <!--   <label for="salesRep" class="col-sm-4 col-form-label ">Sales Rep</label>
                        <div class="col-sm-8">
                          <select class="form-control select2tag select2-hidden-accessible"  (change)='getSalesRepDetails($event.target.value,"")'   tabindex="-1" aria-hidden="true" >
                            <option value=""  disabled selected>Select</option>
                           <option data-tagprefix=''*ngFor='let rep of allSalesRep' value={{rep.id}}>{{rep.fullName}}</option>
                          </select></div>-->
                          
                          <div class="ml-5 w-100" *ngFor='let rep of allSalesRep' style="overflow: auto; float:right; max-height: 550px;">
<div  >
                          <input type="checkbox"  class="form-check-input mt-2 " [checked]="isChecked(rep.userID)"  (change)="selectSalesRep($event.target.checked,'schedule',rep)">
                          <label class="form-check-label px-1 pb-2 w-100">
                            {{rep.fullName}}
                          </label>
                        </div>
                       </div>
                    </div>
                  
              
                       <div class="form-group row " *ngIf="salesrepselected">
                  
                        <label for="userID" class="col-sm-4 col-form-label " translate>ID</label>
                        <div class="col-sm-8">
                        <input class="border-0 " disabled formControlName="userID"> </div>
                          
                       </div>

                       <div class="form-group row " *ngIf="salesrepselected">
                  
                        <label for="email" class="col-sm-4 col-form-label " translate>Email</label>
                        <div class="col-sm-8">
                        <input class="border-0 " disabled formControlName="email"> </div>
                          
                       </div>

                       <div class="form-group row " *ngIf="salesrepselected">
                  
                        <label for="phone" class="col-sm-4 col-form-label " translate>Phone</label>
                        <div class="col-sm-8">
                        <input class="border-0 " disabled formControlName="phone"> </div>
                          
                       </div>
                 
                  <div class="modal-footer">
                   <button type="button" class="btn btn-secondary" (click)="modal.dismiss()" translate>Close</button>
                   <button type="submit" class="btn btn-primary" (click)=addMultipleSalesRepToMainlist(); translate>Add</button>
                  </div>
                 </form>
                </div>
               </ng-template> 
          
          
          
          
          
          
          
          
          
          
       
   
   
   